import React from 'react';
import ReactDOM from 'react-dom';
import { initSentry } from '@qwkin/sentry';
import App from './App';
import { version } from '../package.json';

initSentry({ version });

ReactDOM.render(<App />, document.getElementById('root'));
